<!-- SwipFx Dashboard (Bootstrap 5) -->
<!-- Assumes Bootstrap CSS + Icons are included in your index.html -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Dashboard'"></app-header>

    <!-- PAGE -->
    <main class="container py-4">

        <!-- HEADER ROW -->
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
            <div>
                <h4 class="mb-0 fw-bold">Dashboard</h4>
                <div class="text-muted small">Balances, quick actions, and instant trading</div>
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-outline-secondary btn-sm" [disabled]="loading" (click)="refresh()">
                    <span *ngIf="!loading">Refresh</span>
                    <span *ngIf="loading">Refreshing...</span>
                </button>
            </div>
        </div>


        <!-- LOADING SKELETON -->
        <div *ngIf="loading" class="card shadow-sm border-0">
            <div class="card-body p-4">
                <div class="placeholder-glow">
                    <div class="placeholder col-12 mb-2"></div>
                    <div class="placeholder col-12 mb-2"></div>
                    <div class="placeholder col-12 mb-2"></div>
                    <div class="placeholder col-10 mb-2"></div>
                    <div class="placeholder col-8"></div>
                </div>
            </div>
        </div>

        <!-- WALLET BOXES -->
        <div *ngIf="!loading" class="row g-3 mb-4">
            <!-- Card 1 -->
            <div class="col-12 col-md-6 col-lg-4" *ngFor="let walletRow of (userData?.wallets ?? []); index as i">
                <div class="card wallet-card border-0 h-100" [routerLink]="['/wallets/manage', walletRow.walletId]">
                    <div class="card-body p-3">
                        <div class="d-flex align-items-start justify-content-between">
                            <div class="small text-muted fw-semibold">{{ walletRow.currency.code }}</div>
                            <span
                                class="badge text-bg-success-subtle border border-success-subtle text-success">{{walletRow.status}}</span>
                        </div>

                        <div class="text-center py-3">
                            <div class="text-muted small mb-1">Balance</div>
                            <div class="fs-4 fw-bold">{{ walletRow.availableBalance | smartAmount:walletRow.currency.symbol }}</div>
                            <small>{{ walletRow.balance | smartAmount:walletRow.currency.symbol }}</small>
                        </div>

                        <div class="d-flex justify-content-center gap-3">
                            <a [routerLink]="['/wallets/deposit', walletRow.walletId]"
                                class="small text-decoration-none">Deposit</a>
                            <a [routerLink]="['/wallets/withdraw', walletRow.walletId]"
                                class="small text-decoration-none">Withdraw</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Shared order entry -->
        <app-order-entry
            title="Quick Order"
            [currencies]="currencies"
            [fee]="fee"
            [loading]="loading">
        </app-order-entry>
        
        <app-footer></app-footer>

    </main>
</div>
